import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة نسبة الخصم";
const DESCRIPTION =
  "احسب مقدار الخصم والسعر النهائي بعد تطبيق نسبة الخصم على السعر الإجمالي. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة مقدار الخصم والمبلغ الذي ستوفره.";
const KEYWORDS = "حاسبة, خصم, نسبة, توفير, سعر";
const OG_URL = "https://do-calculate.com/calculator/ar/discount-calculator/";
function DiscountCalculator() {
  const [totalPrice, setTotalPrice] = useState("0");
  const [discountPercentage, setDiscountPercentage] = useState("0");
  const [discountAmount, setDiscountAmount] = useState(null);
  const [finalPrice, setFinalPrice] = useState(null);
  const [error, setError] = useState("");
  const calculateDiscount = () => {
    try {
      if (totalPrice === "0" && discountPercentage === "0") {
        setError("الرجاء إدخال قيم من أجل حساب النسبة");
        return;
      }
      const discount = (totalPrice * discountPercentage) / 100;
      const final = totalPrice - discount;
      setDiscountAmount(discount);
      setFinalPrice(final);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  توفر هذه الحاسبة طريقة بسيطة لحساب الخصم والسعر النهائي بعد
                  تطبيق نسبة خصم على السعر الإجمالي. باستخدام هذه الحاسبة، يمكنك
                  بسهولة معرفة مقدار المال الذي ستوفره عند شراء منتج معين. كل ما
                  عليك فعله هو إدخال السعر الإجمالي للمنتج ونسبة الخصم، وسوف
                  تعرض لك الحاسبة مقدار الخصم والسعر النهائي الذي ستدفعه.
                </p>
                <p>
                  على سبيل المثال، إذا كان لديك منتج بسعر 100 دولار ونسبة الخصم
                  20%، يمكنك استخدام هذه الحاسبة لتحديد مقدار الخصم الذي ستحصل
                  عليه، وأيضًا لمعرفة السعر النهائي الذي ستدفعه بعد تطبيق الخصم.
                  إن معرفة هذه التفاصيل مسبقًا يمكن أن يساعدك في اتخاذ قرارات
                  شراء مستنيرة.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="total-price">السعر الإجمالي:</label>
                    <input
                      id="total-price"
                      type="number"
                      value={totalPrice}
                      onChange={(e) => setTotalPrice(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="discount">نسبة الخصم:</label>
                    <input
                      id="discount"
                      type="number"
                      value={discountPercentage}
                      onChange={(e) => setDiscountPercentage(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text ">%</span>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateDiscount}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  discountAmount !== null &&
                  finalPrice !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>مقدار الخصم: {discountAmount.toFixed(2)}</p>
                      <p>السعر النهائي: {finalPrice.toFixed(2)}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية حساب نسبة الخصم</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: تحديد السعر الإجمالي
                    </h2>
                  </u>
                  <p>
                    في البداية، يجب عليك تحديد السعر الإجمالي للمنتج الذي تريد
                    حساب الخصم عليه. السعر الإجمالي هو السعر قبل تطبيق أي خصم.
                    يعتبر هذا السعر الأساسي للنظر في الخصم الذي سيتم تطبيقه.
                    تأكد من إدخال السعر الإجمالي الصحيح لأن ذلك سيؤثر مباشرة على
                    الحسابات التي ستتم لاحقًا. بعد تحديد السعر الإجمالي، يمكنك
                    الانتقال إلى الخطوة التالية التي تتعلق بإدخال نسبة الخصم.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: إدخال نسبة الخصم
                    </h2>
                  </u>
                  <p>
                    في هذه الخطوة، يجب عليك إدخال نسبة الخصم التي تريد تطبيقها
                    على السعر الإجمالي. نسبة الخصم هي القيمة المئوية التي سيتم
                    خصمها من السعر الإجمالي للمنتج. على سبيل المثال، إذا كانت
                    نسبة الخصم 20%، فهذا يعني أنك ستوفر 20% من السعر الإجمالي.
                    إدخال نسبة الخصم بشكل صحيح هو أمر ضروري لضمان دقة الحسابات
                    النهائية التي ستظهرها الحاسبة.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: حساب مقدار الخصم
                    </h2>
                  </u>
                  <p>
                    بعد إدخال السعر الإجمالي ونسبة الخصم، يمكنك حساب مقدار الخصم
                    بسهولة. للقيام بذلك، اضرب السعر الإجمالي في نسبة الخصم ثم
                    اقسم الناتج على 100. هذا الحساب سيعطيك مقدار الخصم الذي سيتم
                    خصمه من السعر الإجمالي. على سبيل المثال، إذا كان السعر
                    الإجمالي هو 100 دولار ونسبة الخصم هي 20%، فإن مقدار الخصم
                    سيكون 20 دولار.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كان السعر الإجمالي 100 دولار ونسبة الخصم 20%، فإن
                    مقدار الخصم هو 20 دولار.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: تحديد السعر النهائي
                    </h2>
                  </u>
                  <p>
                    الخطوة الأخيرة هي تحديد السعر النهائي الذي ستدفعه بعد تطبيق
                    الخصم. للحصول على السعر النهائي، قم بطرح مقدار الخصم من
                    السعر الإجمالي. هذا سيعطيك السعر النهائي الذي يجب عليك دفعه
                    بعد الخصم. هذه الخطوة مهمة لأنها توضح لك المبلغ الفعلي الذي
                    ستدفعه بعد الخصم، مما يساعدك في إدارة ميزانيتك بشكل أفضل.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: 100 دولار - 20 دولار = 80 دولار (السعر النهائي).
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DiscountCalculator;
